import { memo } from 'react';

import { LightbulbIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

import styles from './SubHeaderRecommended.module.scss';

interface Props {
  onDisMissClick: () => void;
  onAcceptClick: () => void;
  title: string;
}
function SubHeaderRecommended({ title, onDisMissClick, onAcceptClick }: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.information}>
        <span className="text-base leading-6 font-semibold text-foreground">{title}</span>
        <LightbulbIcon size={16} className="text-foreground-muted" />
      </div>
      <div className={styles.buttonContainer}>
        <Button onClick={onDisMissClick} type="submit" variant="outline-neutral" size="sm">
          {t('common.reject')}
        </Button>

        <Button onClick={onAcceptClick} type="submit" size="sm">
          {t('common.accept_and_edit')}
        </Button>
      </div>
    </div>
  );
}

export default memo(SubHeaderRecommended);
